import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCountries } from '../../hooks';
import type { Country, CountryFilters } from '../../models';

export interface CountryFieldProps extends Omit<SelectProps<Country>, 'options'> {
  defaultFilters?: Partial<CountryFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<Country>['errorMessage'];
  isInvalid?: boolean;
}

export const CountryField: React.FC<CountryFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useCountries(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { countryName: search ?? '' } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { countryName: search ?? '' } })}
      isLoading={isLoading}
    />
  );
};
